import { EFonts } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    imgSrc: string;
    label: string;
    isActive: boolean;
    onClick: () => void;
}

export const MapV2CategoryButton = (props: Props): JSX.Element => {
    return (
        <S_MapV2CategoryButton
            className={props.className}
            $isActive={props.isActive}
            onClick={props.onClick}
        >
            {props.imgSrc && (
                <S_IconContainer>
                    <S_Icon $imgSrc={props.imgSrc} $isActive={props.isActive} />
                </S_IconContainer>
            )}
            <S_Text>{props.label}</S_Text>
        </S_MapV2CategoryButton>
    );
};

const S_Icon = styled.div<{ $imgSrc: string; $isActive }>`
    width: 32px;
    height: 32px;
    background-image: url(${(props) => props.$imgSrc});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    ${(props) =>
        !props.$isActive &&
        css`
            filter: grayscale(100%);
        `}
`;

const S_MapV2CategoryButton = styled.div<{ $isActive: boolean }>`
    height: 45px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    cursor: pointer;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
    background: ${(props) => (props.$isActive ? '#FFFFE5' : '#fff')};
    user-select: none;
    &:hover {
        background: #f5f5f5;
        ${S_Icon} {
            filter: unset !important;
        }
    }
`;

const S_IconContainer = styled.div`
    height: 45px;
    width: 45px;
    background: #f5f5f5;
    border-radius: 10px 0 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const S_Text = styled.div`
    font-family: ${EFonts.InterSemiBold};
    padding: 14px 15px;
    font-size: 15px;
    margin: -1px 0 0 0;
    white-space: nowrap;
`;
